const map = {
	"./chicken-burger-tier-1.png": 2753,
	"./chicken-burger-tier-1.webp": 6829,
	"./chicken-burger-tier-2.png": 2170,
	"./chicken-burger-tier-2.webp": 4000,
	"./chicken-burger-tier-3.png": 7379,
	"./chicken-burger-tier-3.webp": 9763,
	"./chicken-burger-tier-4.png": 2508,
	"./chicken-burger-tier-4.webp": 4478,
	"./chicken-burger-tier-5.png": 9045,
	"./chicken-burger-tier-5.webp": 505,
	"./crepe-nutella-tier-1.png": 577,
	"./crepe-nutella-tier-1.webp": 5543,
	"./crepe-nutella-tier-2.png": 9498,
	"./crepe-nutella-tier-2.webp": 9926,
	"./crepe-nutella-tier-3.png": 5059,
	"./crepe-nutella-tier-3.webp": 6033,
	"./crepe-nutella-tier-4.png": 7660,
	"./crepe-nutella-tier-4.webp": 760,
	"./crepe-salee-tier-1.png": 7866,
	"./crepe-salee-tier-1.webp": 4982,
	"./crepe-salee-tier-2.png": 8945,
	"./crepe-salee-tier-2.webp": 455,
	"./crepe-salee-tier-3.png": 7816,
	"./crepe-salee-tier-3.webp": 5748,
	"./crepe-salee-tier-4.png": 9959,
	"./crepe-salee-tier-4.webp": 5957,
	"./dowhile-burger-tier-1.png": 6470,
	"./dowhile-burger-tier-1.webp": 5280,
	"./dowhile-burger-tier-2.png": 8237,
	"./dowhile-burger-tier-2.webp": 9533,
	"./dowhile-burger-tier-3.png": 8644,
	"./dowhile-burger-tier-3.webp": 6770,
	"./dowhile-burger-tier-4.png": 3451,
	"./dowhile-burger-tier-4.webp": 5551,
	"./dowhile-burger-tier-5.png": 8258,
	"./dowhile-burger-tier-5.webp": 8460,
	"./tacos-poulet-tier-1.png": 5298,
	"./tacos-poulet-tier-1.webp": 5816,
	"./tacos-poulet-tier-2.png": 6265,
	"./tacos-poulet-tier-2.webp": 5221,
	"./tacos-poulet-tier-3.png": 8144,
	"./tacos-poulet-tier-3.webp": 7690,
	"./tacos-poulet-tier-4.png": 3119,
	"./tacos-poulet-tier-4.webp": 3319,
	"./tacos-poulet-tier-5.png": 6182,
	"./tacos-poulet-tier-5.webp": 9140,
	"./tacos-xxl-tier-1.png": 8549,
	"./tacos-xxl-tier-1.webp": 811,
	"./tacos-xxl-tier-2.png": 1198,
	"./tacos-xxl-tier-2.webp": 4522,
	"./tacos-xxl-tier-3.png": 9511,
	"./tacos-xxl-tier-3.webp": 7877,
	"./tacos-xxl-tier-4.png": 4344,
	"./tacos-xxl-tier-4.webp": 3668,
	"./tacos-xxl-tier-5.png": 2209,
	"./tacos-xxl-tier-5.webp": 7703
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3924;